import {Card, css, Stack, styled} from '@mui/material';
import {StyledCardContainerType} from './types';

const StyledCardContainer = styled(Card)<StyledCardContainerType>`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 24px;
	gap: 16px;
	box-shadow: none;

	${({isMobile}) =>
		isMobile
			? css`
					flex-direction: column;
				`
			: null}
`;

const StyledContent = styled(Stack)`
	gap: 16px;
	max-width: 401px;
`;

export {StyledCardContainer, StyledContent};
